import React from 'react';
import moment from 'moment';
import { AvatarTeam, Subhead, Text } from 'components/shared/uniform';
import { getSportByName } from 'components/shared/uniform/sport-helpers';

class UpcomingEvents extends React.Component {
  static propTypes = {
    sportName: React.PropTypes.string,
    divider: React.PropTypes.bool.isRequired,
    events: React.PropTypes.arrayOf(React.PropTypes.shape({
      gameId: React.PropTypes.string.isRequired,
      isHome: React.PropTypes.bool.isRequired,
      opponentName: React.PropTypes.string.isRequired,
      opponentTeamId: React.PropTypes.string,
      schoolAbbreviation: React.PropTypes.string,
      primaryColor: React.PropTypes.string,
      secondaryColor: React.PropTypes.string,
      teamLogoUri: React.PropTypes.string,
      unixTime: React.PropTypes.number,
    })),
    teamProfileUrlBase: React.PropTypes.string.isRequired,
    convertTimesToLocal: React.PropTypes.bool.isRequired,
  }

  shouldComponentUpdate(nextProps) {
    return nextProps !== this.props;
  }

  formatDate(utcTime) {
    if (!utcTime) {
      return null;
    }

    // Grab time offset from end of string
    let parsedDate;
    if (this.props.convertTimesToLocal) {
      parsedDate = moment.utc(utcTime.slice(0, -6)).local();
    } else {
      parsedDate = moment.utc(utcTime).utcOffset(utcTime.slice(-6));
    }

    const day = parsedDate.format('D');
    const dayOfWeek = parsedDate.format('dddd');
    let month = parsedDate.format('MMMM');

    if (month === 'September') {
      month = 'Sept.';
    } else {
      month = month.length > 5 ? month.substring(0, 3) + '.' : month;
    }

    const dmy = `${dayOfWeek}, ${day} ${month}`;

    return dmy;
  }

  formatTime(utcTime) {
    if (!utcTime) {
      return null;
    }

    let parsedTime;
    // Grab time offset from end of string
    if (this.props.convertTimesToLocal) {
      parsedTime = moment.utc(utcTime.slice(0, -6)).local();
    } else {
      parsedTime = moment.utc(utcTime).utcOffset(utcTime.slice(-6));
    }

    const time = parsedTime.format('h:mm');
    const amPm = parsedTime.format('a');

    const fullTime = `${time} ${amPm.substring(0, 1)}.${amPm.substring(1, 2)}.`;

    return fullTime;
  }

  render() {
    const upcomingEvents = this.props.events || [];
    if (!upcomingEvents.length) {
      return null;
    }

    const divider = this.props.divider ?
      <div className="section-divider"></div> : null;

    return (
      <div>
        {divider}
        <Subhead className="uni-margin--one--btm">Upcoming</Subhead>
        <ul className="col-team-list">
          {upcomingEvents.map(evt => {
            const date = this.formatDate(evt.utcTime);
            const time = this.formatTime(evt.utcTime);
            const teamName = `${evt.isHome ? 'vs ' : '@ '} ${evt.opponentName}`;
            const teamContent = (
              <div className="team-container">
                <AvatarTeam
                  className="uni-margin--half--right"
                  size="large"
                  imageUrl={evt.opponentLogoUri}
                  sport={getSportByName(this.props.sportName)}
                  primaryColor={evt.primaryColor}
                  secondaryColor={evt.secondaryColor}
                />
                <div className="team-text">
                  <span className="team-name">
                    <Subhead level="subtle">{teamName}</Subhead>
                  </span>
                  <div className="team-subtext">
                    <Text level="small" color="nonessential">{date} at {time}</Text>
                  </div>
                </div>
              </div>
            );

            const linkedContent = evt.opponentTeamId ? (
              <a href={this.props.teamProfileUrlBase + evt.opponentTeamId}>
                {teamContent}
              </a>
            ) : teamContent;

            return (
              <li className={evt.opponentTeamId ? 'selectable' : ''} key={evt.gameId}>
                {linkedContent}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default UpcomingEvents;
